import { useFormik } from "formik";
import queryString from "query-string";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RouteConstants } from "routes/RouteConstants";
import { isOrg } from "utils";
import * as Yup from "yup";
import AuthWrapper from "../components/AuthWrapper";
import DotLoaderCircle from "../components/DotLoaderCircle";
import { redirection_url } from "../constant";
import { handleVerifyAccount } from "../store/actions";

const initialValues = {
  email: "",
};

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required("Email is required.")
    .email("Invalid email."),
});

const UserConformation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { verifyAccountLoading, magicLinkLoading } = useSelector(
    state => state?.NewAuth
  );

  const navigate = useNavigate();
  const query = queryString.parse(location.search);

  const submitConformUser = data => {
    const callback = res => {
      if (res?.is_account) {
        query?.partner
          ? navigate(
              RouteConstants.login +
                `?email=${res?.email}&partner=${query.partner}`
            )
          : navigate(RouteConstants.login + `?email=${res?.email}`);
      } else {
        let payload = {
          user_id: +res?.user_id,
          email: res?.email,
          redirect_url: redirection_url,
          is_user_exists: res?.is_account,
          partner: query?.partner || "",
          site_id: JSON.parse(localStorage.getItem("site_id"))
            ? JSON.parse(localStorage.getItem("site_id"))
            : "2",
          sign_up:
            queryString.parse(JSON.parse(localStorage.getItem("utm_params")))
              ?.sign_up || "",
        };
        if (isOrg) {
          payload.utm_campaign =
            queryString.parse(JSON.parse(localStorage.getItem("utm_params")))
              ?.utm_campaign || "";
          payload.utm_medium =
            queryString.parse(JSON.parse(localStorage.getItem("utm_params")))
              ?.utm_medium || "";
          payload.utm_source =
            queryString.parse(JSON.parse(localStorage.getItem("utm_params")))
              ?.utm_source || "";
          payload.utm_term =
            queryString.parse(JSON.parse(localStorage.getItem("utm_params")))
              ?.utm_term || "";
          payload.utm_content =
            queryString.parse(JSON.parse(localStorage.getItem("utm_params")))
              ?.utm_content || "";
        }
        // const cb = () => {
        //   query?.partner
        //     ? navigate(RouteConstants.resendLink + `?partner=${query.partner}`)
        //     : navigate(RouteConstants.resendLink);
        // };
        // if (get("redirect_url")?.includes(RouteConstants.checkout)) {
        if (!!location.search) {
          navigate(
            `${RouteConstants.signup}${location.search}&email=${res?.email}`
          );
        } else {
          navigate(`${RouteConstants.signup}?email=${res?.email}`);
        }
        // } else {
        //   dispatch(handelSendMagicLink(payload, cb));
        // }
      }
    };
    dispatch(handleVerifyAccount(data, callback));
  };

  const { values, errors, touched, handleSubmit, handleBlur, handleChange } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: submitConformUser,
    });

  const isAllDataAvailable = useMemo(() => {
    return !!!values?.email;
  }, [values?.email]);

  return (
    <AuthWrapper>
      <div className="home-password-wrapper">
        <div className="header-wrapper">
          <h1 className="title">Log in or sign up for free</h1>
          <p className="sub-title">
            Enter your email and we’ll check if you have an account, and help
            create one if you don’t.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="body-wrapper">
            <label className="form-label">Email address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="email@gmail.com"
              value={values?.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors?.email && touched?.email && (
              <div className="form-text text-danger">{errors?.email}</div>
            )}
          </div>
          <div className="footer-wrapper">
            <button
              className="submit-button"
              disabled={
                verifyAccountLoading || isAllDataAvailable || magicLinkLoading
              }
            >
              {verifyAccountLoading || magicLinkLoading ? (
                <DotLoaderCircle text="Continuing" />
              ) : (
                "Continue"
              )}
            </button>
            <p className="footer-text">
              By continuing, you agree to the <br />
              <Link
                target="_blank"
                to="https://growcurriculum.org/terms-of-service"
              >
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link
                target="_blank"
                to="https://growcurriculum.org/privacy-policy"
              >
                Privacy Policy
              </Link>
            </p>
          </div>
        </form>
      </div>
    </AuthWrapper>
  );
};

export default UserConformation;
